import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { HEIGHT_ONE_PERCENT } from '../const';
import useGetGeometryParamForItem from '../hooks/useGetGeometryParamForItem';
import { ComponentsDispatch, RootState } from '../store';
import { setterGantDraggable } from '../store/slices/gantDraggableSlice';
import { DraggableGantType, ItemType } from '../types';

interface IGantItemMarkerBondDrop {
    item: ItemType;
    x: number;
    draggingType?: DraggableGantType;
}

const GantItemMarkerBondDrop: React.FC<IGantItemMarkerBondDrop> = ({ item, x, draggingType }) => {
    const dispatch = useDispatch<ComponentsDispatch>();
    const currentDropBond = useSelector<RootState, ItemType | null>((state) => state.gantDraggable.currentDropBond);
    const currentDragBond = useSelector<RootState, ItemType | null>((state) => state.gantDraggable.currentDragBond);
    const dragging = useSelector<RootState, DraggableGantType>((state) => state.gantDraggable.dragging);

    const geometryParamDragItem = useGetGeometryParamForItem(item);

    const handleMouseUp = () => {
        if (currentDragBond && !currentDropBond) {
            dispatch(setterGantDraggable({ currentDropBond: item }));
        }
    };

    const commonProps: React.SVGProps<SVGRectElement> = {
        onMouseOver: () => {
            const accessDragTypeList: DraggableGantType[] = ['bondLeft', 'bondRight', 'none'];
            if (!accessDragTypeList.includes(dragging)) {
                return;
            }

            if (currentDragBond && currentDragBond.id !== item.id) {
                dispatch(setterGantDraggable({ currentPreDropBond: item, draggingDrop: draggingType }));
            }
        },
        onMouseLeave: () => {
            dispatch(setterGantDraggable({ currentPreDropBond: null, draggingDrop: 'none' }));
        },
        onMouseUp: handleMouseUp,
        cursor: 'alias',
    };

    return (
        <rect
            x={x + (draggingType === 'bondLeft' ? 0 : -geometryParamDragItem.length / 2)}
            fill={'white'}
            y={HEIGHT_ONE_PERCENT * 20}
            width={geometryParamDragItem.length / 2}
            height={HEIGHT_ONE_PERCENT * 60}
            strokeWidth={1}
            opacity={0.001}
            {...commonProps}
        />
    );
};

export default React.memo(GantItemMarkerBondDrop);
